/* import __COLOCATED_TEMPLATE__ from './close-account-or-deactivate-cards.hbs'; */
import Component from '@glimmer/component';
export default class CloseAccountOrDeactivateCards extends Component {
  get hasAuthorizedUserCard() {
    return this.args.cardSummaryList.some(cardSummary => !cardSummary.isAccountHolderCard);
  }
  get accountOwnerCardCount() {
    return this.args.cardSummaryList.filter(cardSummary => cardSummary.isAccountHolderCard).length;
  }
}